<p-dialog
  header="Create Outbound Load from Template"
  [modal]="true"
  [style]="{ width: 'min(98dvw, 1680px)' }"
  [contentStyle]="{ overflow: 'auto' }"
  [dismissableMask]="false"
  [(visible)]="show"
  [closable]="false"
>
  <!-- TODO(nicholas-ramsey): Instead of overriding the header template, in PrimeNG 17+, we can override the closeicon button directly -->
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <span class="p-dialog-title">Create Outbound Load from Template</span>
      <div class="p-dialog-header-icons">
        <button
          type="button"
          pButton
          class="p-dialog-header-icon"
          [attr.aria-label]="'Close dialog'"
          (keydown.enter)="handleClose($event)"
          (click)="handleClose($event)">
          <span class="p-dialog-header-close-icon pi pi-times"></span>
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <label class="p-d-inline-flex p-mb-2 p-ai-center">
      <span class="p-text-bold">Template</span>
      <p-dropdown
        [options]="templateOptions"
        appendTo="body"
        styleClass="p-ml-2"
        placeholder="Select template..."
        [ngModel]="selectedTemplateDefinition"
        (ngModelChange)="onTemplateDefinitionChange($event)"
        (onChange)="resetForm()"
        [filter]="true"
        [resetFilterOnHide]="true"
        [autoDisplayFirst]="false"
      ></p-dropdown>
    </label>

    <p-table *ngIf="selectedTemplate && (sharedTemplateContext | async) as context" [value]="rows" styleClass="p-mb-2" [autoLayout]="true">
      <ng-template pTemplate="header">
        <tr>
          <th aria-label="Row index"></th>
          <th>Status</th>
          <th *ngIf="selectedTemplate.loadDate.isVisible">Date Loaded</th>
          <th *ngIf="selectedTemplate.trailerId.isVisible">Trailer #</th>
          <th *ngIf="selectedTemplate.carrier.isVisible">Carrier</th>
          <th *ngIf="selectedTemplate.shipToLocation.isVisible">Ship To</th>
          <th *ngIf="selectedTemplate.invoiceTo.isVisible">Invoice To</th>
          <th *ngIf="selectedTemplate.pooler.isVisible">Pooler</th>
          <th *ngIf="selectedTemplate.product.isVisible">Product</th>
          <th *ngIf="selectedTemplate.quantity.isVisible">Qty</th>
          <th *ngIf="selectedTemplate.hasShipped.isVisible">Is Shipped</th>
          <th>Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
        <tr [formGroup]="row.formGroup" *ngIf="(row.localContext | async) as localContext">
          <td class="p-text-center">
            <strong>{{rowIndex + 1}}</strong>
          </td>
          <td class="p-text-center">
            <a
              *ngIf="hasCreated(row)"
              [routerLink]="['/', 'loads', 'outbound', row.result.result?.id]"
              target="_blank"
            >
              <button pButton icon="pi pi-external-link" iconPos="right" type="button" label="Created"
                      class="p-button-primary">
              </button>
            </a>

            <span *ngIf="hasErrored(row)" aria-live="polite" aria-label="Load creation failed">
              ERRORED
            </span>
            <span *ngIf="!hasCreated(row) && !hasErrored(row)">
              PENDING
            </span>
          </td>
          <td *ngIf="selectedTemplate.loadDate.isVisible || selectedTemplate.loadTime.isVisible">
            <div class="p-inputgroup">
              <p-calendar inputId="loadDate" formControlName="loadDate" [showIcon]="true" appendTo="body" *ngIf="selectedTemplate.loadDate.isVisible"></p-calendar>
              <time-entry formControlName="loadTime" [timezone]="context.siteTimezone" *ngIf="selectedTemplate.loadTime.isVisible"></time-entry>
            </div>
          </td>
          <td *ngIf="selectedTemplate.trailerId.isVisible">
            <app-trailer-select
              inputId="trailerId"
              name="trailerId"
              formControlName="trailerId"
              eligibleFor="departing"
              [siteSubinventoryId]="row.formGroup.get('siteSubinventory').value?.id"
              [carrier]="row.formGroup.get('carrier').value"
              [excludeTrailerIds]="getExcludedTrailerIds(rowIndex)"
              [addButtonTabIndex]="0"
            >
            </app-trailer-select>
          </td>
          <td *ngIf="selectedTemplate.carrier.isVisible">
            <p-dropdown
              formControlName="carrier"
              [options]="context.carriers"
              [resetFilterOnHide]="true"
              optionLabel="carrierName"
              appendTo="body"
              placeholder="Select Carrier"
            >
            </p-dropdown>
          </td>
          <td *ngIf="selectedTemplate.shipToLocation.isVisible">
            <p-dropdown
              formControlName="shipToLocation"
              [options]="asLocalContext(localContext).shipToLocationOptions ?? []"
              [resetFilterOnHide]="true"
              [virtualScroll]="true"
              [virtualScrollItemSize]="30"
              [filter]="true"
              appendTo="body"
              placeholder="Select Location"
            >
              <ng-template pTemplate="item" let-item let-i>
                <div [ngClass]="item.styleClass" [style]="{'min-height':'2em'}">{{item.label}}</div>
              </ng-template>
            </p-dropdown>
          </td>
          <td *ngIf="selectedTemplate.invoiceTo.isVisible">
            <p-dropdown
              formControlName="invoiceTo"
              [options]="asLocalContext(localContext).customers"
              [resetFilterOnHide]="true"
              optionLabel="accountName"
              appendTo="body"
              placeholder="Select Invoice To"
            >
            </p-dropdown>
          </td>
          <td *ngIf="selectedTemplate.pooler.isVisible">
            <p-dropdown
              formControlName="pooler"
              [options]="asLocalContext(localContext).poolers"
              [resetFilterOnHide]="true"
              optionLabel="accountName"
              appendTo="body"
              placeholder="Select Pooler"
            >
            </p-dropdown>
          </td>
          <td *ngIf="selectedTemplate.product.isVisible">
            <p-dropdown
              formControlName="product"
              [options]="asLocalContext(localContext).products"
              [autoDisplayFirst]="false"
              [resetFilterOnHide]="true"
              [filter]="true"
              appendTo="body"
            ></p-dropdown>
          </td>
          <td *ngIf="selectedTemplate.quantity.isVisible">
            <input type="number" class="quantity-input" formControlName="quantity" pInputText>
          </td>
          <td *ngIf="selectedTemplate.hasShipped.isVisible">
            <p-checkbox
              formControlName="hasShipped"
              [binary]="true"
              class="p-flex-row p-jc-center"
            >
            </p-checkbox>
          </td>
          <td class="p-text-nowrap">
            <button pButton *ngIf="hasCreated(row)" pTooltip="Print BOL" class="p-button-secondary" icon="pi pi-print" (click)="printLoad(row)"></button>
            <button
              pButton
              icon="pi pi-clone"
              pTooltip="Clone row"
              (click)="showClonePanel($event, rowIndex)"
            ></button>
            <button
              pButton
              *ngIf="!hasCreated(row)"
              icon="pi pi-trash"
              class="p-button-danger"
              pTooltip="Remove row"
              (click)="removeRow(rowIndex)"
            ></button>
          </td>
        </tr>

        <tr *ngIf="row.formGroup.get('hasShipped').value && !hasCreated(row)">
          <td colspan="2" class="subtable-container"></td>
          <td colspan="10" class="subtable-container">
            <p-table [value]="[row.formGroup]" [autoLayout]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th>Scheduled Pickup Date/Time</th>
                  <th>Shipped Date/Shift</th>
                  <th>Time Shipped</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [formGroup]="row">
                  <td>
                    <div class="p-inputgroup">
                      <p-calendar
                        inputId="scheduledPickupDate"
                        [showIcon]="true"
                        formControlName="scheduledPickupDate"
                        appendTo="body"
                      >
                      </p-calendar>
                      <time-entry formControlName="scheduledPickupTime" [timezone]="context.siteTimezone"></time-entry>
                    </div>
                  </td>

                  <td>
                    <app-worked-shift-selector
                      formControlName="shippedShiftId"
                      [disabled]="row.get('shippedShiftId').disabled"
                      (dateSelected)="onShippedShiftDateChanged($event, rowIndex)"
                    >
                    </app-worked-shift-selector>
                  </td>

                  <td>
                    <div class="p-inputgroup">
                      <p-calendar inputId="dateShipped" formControlName="dateShipped" [showIcon]="true" appendTo="body"></p-calendar>
                      <time-entry inputId="timeShipped" formControlName="timeShipped" [timezone]="context.siteTimezone"
                                  [displaySeconds]="false"></time-entry>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="form-actions">
      <button
        pButton
        icon="pi pi-plus"
        label="Add Row"
        aria-label="Add Row"
        (click)="addRow()"
        [disabled]="loading || !selectedTemplate"
        class="mt-2"
      ></button>
      <button
        pButton
        label="Create Loads"
        aria-label="Create Loads"
        icon="pi pi-plus"
        type="button"
        [loading]="loading"
        [disabled]="loading || invalid || !selectedTemplate"
        (click)="saveLoads()"
        class="p-button-success"
      ></button>
    </div>

    <p-overlayPanel #clonePanel [dismissable]="true" (onHide)="cloneInput.value = '1'" styleClass="p-p-1" appendTo="body">
      <div class="p-fluid">
        <label for="cloneCountInput" class="p-mb-2">Number of duplicates to create</label>
        <div class="p-inputgroup">
          <input
            #cloneInput
            id="cloneCountInput"
            type="number"
            pInputText
            [value]="1"
            min="1"
            [max]="maxClones"
            (keydown.enter)="confirmClone(cloneInput.valueAsNumber)"
            (keydown.escape)="clonePanel.hide()"
            [autofocus]="true"
          />
          <button
            pButton
            icon="pi pi-check"
            class="p-button-success"
            (click)="confirmClone(cloneInput.valueAsNumber)"
            [disabled]="cloneInput.valueAsNumber < 1"
          ></button>
        </div>
      </div>
    </p-overlayPanel>
  </ng-template>

  <p-confirmDialog></p-confirmDialog>
</p-dialog>
